import React, { Children, useState } from "react";
import GuideStepContext, { type GuideStepContextValue } from "./GuideStepContext";
import type { GuideProps } from "../NativeGuideTypes";

interface GuideSequenceProps extends GuideProps {
  children: React.ReactNode;
}

const GuideSequence: React.FC<GuideSequenceProps> = ({
  guideId,
  children,
  onComplete,
  onDismiss
}) => {
  const [stepIndex, setStepIndex] = useState(0);
  const steps = Children.toArray(children);
  const total = steps.length;
  const isFirst = stepIndex === 0;
  const isLast = stepIndex === total - 1;

  const value: GuideStepContextValue = {
    guideId,
    stepIndex,
    onComplete,
    onDismiss,
    onNext: isLast ? undefined : () => setStepIndex(i => i + 1),
    onPrev: isFirst ? undefined : () => setStepIndex(i => i - 1),
    stepIndicator: total > 1 ? `${stepIndex + 1} / ${total}` : undefined,
    isLast
  };

  return <GuideStepContext.Provider value={value}>{steps[stepIndex]}</GuideStepContext.Provider>;
};

export default GuideSequence;
